import interactiveElementSelector from '../interactiveElementSelector';

var isElementFocusable = function isElementFocusable(element) {
  var isVisible = !element.hidden;
  return isVisible && element.matches(interactiveElementSelector);
};

export default isElementFocusable;